import gql from 'graphql-tag';

export const UPSERT_BROADCAST = gql`
  mutation UpsertBroadcast($input: UpsertBroadcastInput!) {
    broadcast {
      upsertBroadcast(input: $input) {
        entity {
          broadcastId
          accountId
          type
          title
          body
          status
          effectiveDateTime
        }
        error
        success
      }
    }
  }
`;
